import React from "react";
import { AHSeparator, Box } from "arkh";
import { graphql, useFragment } from "react-relay";
import { SectionSubItemContainer } from "../../components/SectionSubItemContainer";
import { KPIEditSectionsListItem } from "./KPIEditSectionsListItem";

type Props = {
  team: any;
  title: string | null;
  goalValue: number;
  isLast: boolean;
  goalDirection: "greater" | "less";

  setGoalValue?(_: number): void;
  onEditSubsection(): void;
};

export function KPIEditSectionsComponentSubItemListItem(props: Props) {
  const team = useFragment(
    graphql`
      fragment KPIEditSectionsComponentSubItemListItem_Team on Team {
        name
        color
      }
    `,
    props.team
  );

  return (
    <Box color="surface" spaceHorizontal="medium">
      <SectionSubItemContainer color={team.color} isLast={props.isLast}>
        <KPIEditSectionsListItem
          dynamicHeight
          space="medium"
          spaceLeft="small"
          name={props.title ?? team.name ?? ""}
          goalDirection={props.goalDirection}
          goalValue={props.goalValue}
          setGoalValue={props.setGoalValue}
          onEditSubsection={props.onEditSubsection}
        />
        {!props.isLast ? <AHSeparator /> : null}
      </SectionSubItemContainer>
    </Box>
  );
}
